<template>
  <div class="ibox">
    <div class="ibox-title">
      <h5>Plugins</h5>
    </div>
    <div class="ibox-content ibox-heading">
      To activate plugins please contact us at
      <a href="mailto:support@colonyhq.com">support@colonyhq.com</a>
      so that we can assist you in activating some of the great plugins we have to offer.
    </div>
    <div class="ibox-content no-padding">
      <ul class="list-group" v-loading="loading">
        <li class="list-group-item" v-for="(plugin, index) in plugins" :key="plugin.id">
          <span class="label label-success pull-right">Enabled</span>
          <span class="label">{{ index + 1 }}</span>
          <span class="title">{{ plugin.plugin_display }}</span>
          <p class="text-muted p-xs">
            {{ pluginDescriptions[plugin.plugin_route] }}
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PluginsList',
  props: ['plugins', 'loading'],
  data: () => ({
    pluginDescriptions: {
      'app.dashboard.radio': 'Colony Radio Dashboard',
      'app.dashboard.analytics': 'Colony Analytics Reports Dashboard',
      'app.chat': 'Colony Chat Service',
      'app.profiles': 'Colony Profile',
      'app.afstereo': 'Afstereo Dashboard',
      'app.dashboard.qualitative': 'Colony Survey Builder',
      'app.profiles.permissions': 'Colony Personal Information Management',
      'app.dashboard.audio_transcriber': 'Colony Audio Transcriber',
      'app.profiles.segmentation': 'Colony Audience Segmentation',
    },
  }),
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// PluginList.vue?3b57f490